export const getBirthCountries = ({ listCountries, isRegisteringWithMainDocumentType }) => {
    const getCountriesAndSortByOriginCountry = (acc, country) => {
        if (__ORIGIN_COUNTRY__ === country.value && isRegisteringWithMainDocumentType) {
            return [country, ...acc];
        }

        return [...acc, country];
    };

    return listCountries.reduce(getCountriesAndSortByOriginCountry, []);
};
